import { postCreateTask } from 'api';
import { useMutation, UseMutationResult } from 'react-query';
import { ICreateTaskErrorResponse, ICreateTaskPayload, ICreateTaskSuccessResponse } from 'models';

interface Props {
  onSuccess?: (res: ICreateTaskSuccessResponse) => void;
  onError?: (err: ICreateTaskErrorResponse) => void;
}

export const usePostCreateTask = ({
  onSuccess,
  onError,
}: Props): UseMutationResult<ICreateTaskSuccessResponse, ICreateTaskErrorResponse, ICreateTaskPayload> => {
  const mutation = useMutation((props: ICreateTaskPayload) => postCreateTask(props), {
    onSuccess: (res) => {
      if (res.status === 'ok') {
        if (onSuccess) onSuccess(res);
        return;
      }

      alert(res.message);
    },
    onError: (err: any) => {
      if (onError) {
        onError(err);
      }

      alert(err.response.message);
    },
  });

  return mutation;
};

export default usePostCreateTask;
